export const tools = [
  {
    title: "GitHub",
    image: "/assets/images/github.svg",
    description: "Version control for code. Share and collaborate.",
  },
  {
    title: "Jira",
    image: "/assets/images/jira.webp",
    description: "Agile project management for software development.",
  },
  {
    title: "Postman",
    image: "/assets/images/postman.svg",
    description:
      "API platform for developers to design, build, test, and collaborate on APIs.",
  },
  {
    title: "ClickUp",
    image: "/assets/images/clickup.webp",
    description: "All-in-one project management for teams.",
  },
  {
    title: "VSCode",
    image: "/assets/images/vscode.webp",
    description: "Lightweight, customizable code editor.",
  },
  {
    title: "Claude Code",
    image: "/assets/images/claude.svg",
    description: "AI coding agent for faster development.",
  },
  {
    title: "Android Studio",
    image: "/assets/images/android-studio.webp",
    description: "Build native Android apps for all screens.",
  },
  {
    title: "Xcode",
    image: "/assets/images/xcode.webp",
    description: "Develop apps for Apple devices (iOS, iPadOS, macOS).",
  },
];

export const technologies = [
  {
    title: "Saas",
    image: "/assets/images/sass.svg",
    description: "CSS extension adding variables, nesting, and mixins for better stylesheet maintainability.",
  },
  {
    title: "Tailwind CSS",
    image: "/assets/images/tailwind.svg",
    description: "Utility-first CSS framework for building custom designs quickly.",
  },
  {
    title: "React",
    image: "/assets/images/react.svg",
    description: "JavaScript library for building user interfaces.",
  },
  {
    title: "Node.js",
    image: "/assets/images/nodejs.svg",
    description:
      "JavaScript runtime environment for building server-side apps.",
  },
  {
    title: "MySQL",
    image: "/assets/images/mysql.svg",
    description: "Open-source relational database management system.",
  },
  {
    title: "PostgreSQL",
    image: "/assets/images/postgresql.svg",
    description:
      "Advanced open-source relational database with strong SQL and JSON support.",
  },
  {
    title: "MongoDB",
    image: "/assets/images/mongodb.svg",
    description: "NoSQL database for flexible data storage.",
  },
  {
    title: "Express.js",
    image: "/assets/images/express.svg",
    description: "Web framework for building web applications on Node.js.",
  },
  {
    title: "Flutter",
    image: "/assets/images/flutter.svg",
    description: "Cross-platform framework for building native mobile apps.",
  },
  {
    title: "Ionic",
    image: "/assets/images/ionic.svg",
    description: "Cross-platform framework for building hybrid mobile apps.",
  },
  {
    title: "Firebase",
    image: "/assets/images/firebase.svg",
    description:
      "Platform for building mobile and web apps. (Backend-as-a-Service)",
  },
  {
    title: "Supabase",
    image: "/assets/images/supabase.svg",
    description:
      "Open-source Firebase alternative with Postgres, auth, storage, and realtime APIs.",
  },
  {
    title: "AWS",
    image: "/assets/images/aws.svg",
    description: "Cloud platform for hosting, storage, databases, and scalable infrastructure.",
  },
  {
    title: "Docker",
    image: "/assets/images/docker.svg",
    description: "Containerization platform for packaging and deploying apps consistently.",
  },
  {
    title: "CI/CD",
    image: "/assets/images/cicd.svg",
    description: "Automated build, test, and deployment pipelines for faster, reliable releases.",
  },
];
